export default __webpack_public_path__ + "static/media/ShellyAnnOldham.eb797b9e.jpg";